/**
 * Show messages
 */
var autoCloseMessage;

function showMessage(messageHtml) {
	clearTimeout(autoCloseMessage);

	const messageContainer = document.getElementById('messages-container');
	messageContainer.classList.add('hidden-message-item');

	messageContainer.innerHTML = messageHtml;

	setTimeout(() => {
		messageContainer.classList.remove('hidden-message-item');
	}, 100);

	/**
	 * Auto close after 5 seconds
	 */
	autoCloseMessage = setTimeout(() => {
		messageContainer.classList.add('hidden-message-item');
	}, 5000);
}

/**
 * Messages component
 */
class MessageItem extends HTMLElement {
	constructor() {
		super();

		const closeButton = this.querySelector('.close-message');
		closeButton.addEventListener('click', this.closeMessage.bind(this));
	}

	closeMessage() {
		const messagesContainer = this.closest('.messages-container');
		messagesContainer.classList.add('hidden-message-item');
	}
}

customElements.define('tpt-message-item', MessageItem);

/**
 * Modal component
 */

class ModalComponent extends HTMLElement {
	constructor() {
		super();

		const currentModalId = this.getAttribute('id');
		const btnOpenElement = document.querySelectorAll('a[data-modal-target="' + currentModalId + '"]');
		const closeModalButton = this.querySelectorAll('[data-close="modal"]');
		const dontShowButton = this.querySelector('tpt-dont-show');
		const modalHeader = this.querySelector('tpt-modal-header');

		modalHeader.addEventListener('touchmove', this.closeModal);
		this.addEventListener('click', this.closeModalComponent);
		this.addEventListener('keydown', this.keyDown.bind(this));

		btnOpenElement.forEach((element) => {
			element.addEventListener('click', this.showModal.bind(this));
		});

		if (dontShowButton) {
			dontShowButton.addEventListener('click', this.dontShowModalAgain);
		}

		if (sessionStorage.getItem('modal-dont-show-' + currentModalId) === 'false' || sessionStorage.getItem('modal-dont-show-' + currentModalId) === null) {
			if (this.getAttribute('data-auto-open') == 'true') {
				let timeDelay = 0;
				const autoOpenModal = this;

				if (autoOpenModal.getAttribute('data-time-delay')) {
					timeDelay = autoOpenModal.getAttribute('data-time-delay') * 1000;
				}

				setTimeout(function () {
					autoOpenModal.classList.add('show');
					document.getElementsByTagName('html')[0].classList.add('open-modal');
				}, timeDelay);
			}
		}

		closeModalButton.forEach((element) => {
			element.addEventListener('click', this.closeModal);
		});
	}

	showModal(e) {
		e.preventDefault();

		const modalId = this.getAttribute('id');
		const btnOpenModal = document.querySelector('[data-modal-target="' + modalId + '"]');

		if (btnOpenModal.classList.contains('active')) {
			btnOpenModal.classList.remove('active');
			btnOpenModal.setAttribute('aria-expanded', false);
			document.getElementsByTagName('html')[0].classList.remove('open-modal');
			this.classList.remove('show');

			setTimeout(() => {
				document.getElementById(modalId).focus();
			}, 300);

			return;
		} else {
			btnOpenModal.classList.add('active');
			btnOpenModal.setAttribute('aria-expanded', true);
			document.getElementsByTagName('html')[0].classList.add('open-modal');
			this.classList.add('show');

			setTimeout(() => {
				document.getElementById(modalId).focus();
			}, 300);

			this.scrollTop = 0;

			return;
		}
	}

	keyDown(e) {
		if (e.keyCode === 27) {
			this.closeModal();
		}

		if (e.keyCode === 9) {
			const currentModal = this;

			setTimeout(() => {
				const focusItem = document.activeElement;

				if (!focusItem.closest('tpt-modal-component') || focusItem.tagName == 'BODY') {
					currentModal.querySelector('[tabindex]').focus();
				}
			}, 200);
		}
	}

	closeModal() {
		const closeButton = this;

		const currentModalId = this.closest('tpt-modal-component').getAttribute('id');
		const btnDontShow = this.closest('tpt-modal-component').querySelector('tpt-dont-show');

		if (btnDontShow) {
			if (btnDontShow.classList.contains('active')) {
				sessionStorage.setItem('modal-dont-show-' + currentModalId, 'true');
			} else {
				sessionStorage.setItem('modal-dont-show-' + currentModalId, 'false');
			}
		}

		this.closest('tpt-modal-component').classList.remove('show');

		const buttonModal = document.querySelectorAll('[data-modal-target="' + currentModalId + '"]');

		if (buttonModal) {
			buttonModal.forEach((buttonTarget) => {
				buttonTarget.classList.remove('active');
				buttonTarget.setAttribute('aria-expanded', false);
			});
		}

		setTimeout(function () {
			const modalCount = document.querySelectorAll('tpt-modal-component.show').length;

			if (modalCount < 1) {
				document.getElementsByTagName('html')[0].classList.remove('open-modal');
			}
		}, 200);

		setTimeout(function () {
			if (closeButton.closest('tpt-modal-component').classList.contains('quickview-modal')) {
				if (document.getElementById(currentModalId)) {
					document.getElementById(currentModalId).remove();
				}
			}

			if (closeButton.closest('tpt-modal-component').classList.contains('tpt-product-live__modal')) {
				closeButton.closest('tpt-modal-component').remove();
			}
		}, 400);
	}

	closeModalComponent(e) {
		if (e.target !== this) {
			return;
		} else {
			this.closeModal();
		}
	}

	dontShowModalAgain() {
		this.classList.toggle('active');
	}
}

customElements.define('tpt-modal-component', ModalComponent);

class OpenModalComponent extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.openModal);
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.openModal(e);
		}
	}

	openModal(e) {
		e.preventDefault();

		const modalId = this.getAttribute('data-modal-target');
		const modalComponent = document.getElementById(modalId);

		//const btnOpenModal = this;

		if (this.classList.contains('active')) {
			this.classList.remove('active');

			this.setAttribute('aria-expanded', false);

			document.getElementsByTagName('html')[0].classList.remove('open-modal');
			modalComponent.classList.remove('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		} else {
			this.classList.add('active');

			this.setAttribute('aria-expanded', true);

			document.getElementsByTagName('html')[0].classList.add('open-modal');
			modalComponent.classList.add('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		}
	}
}

customElements.define('tpt-open-modal', OpenModalComponent);

/**
 * Init swiper slider
 */
class SwiperSliderComponent extends HTMLElement {
	constructor() {
		super();

		const swiper = this.querySelector('.swiper');
		const optionString = this.querySelector('tpt-slider-options').innerHTML;
		const optionsJson = JSON.parse(optionString);
		const nextButton = this.querySelector('.swiper-button-next');
		const prevButton = this.querySelector('.swiper-button-prev');
		const pagination = this.querySelector('.swiper-paginations');

		let options = {
			...optionsJson,
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
			pagination: {
				el: pagination,
				clickable: true,
			},
		};

		new Swiper(swiper, options);
	}
}

customElements.define('tpt-slider-component', SwiperSliderComponent);

/**
 * Tab popup component
 */

class PopupTabs extends HTMLElement {
	constructor() {
		super();

		const btnOpen = document.querySelectorAll('[data-tab-popup-target]');

		btnOpen.forEach((btnItem) => {
			btnItem.addEventListener('click', this.showModal);
		});
	}

	showModal(e) {
		e.preventDefault();

		const currentModalId = this.getAttribute('data-tab-popup-target');
		const currentModal = document.getElementById(currentModalId);
		const currentTabTrigger = this.getAttribute('data-item-tab-target');

		currentModal.querySelector('[data-tab-target="' + currentTabTrigger + '"]').click();

		document.getElementsByTagName('html')[0].classList.add('open-modal');
		currentModal.classList.add('show');
		this.scrollTop = 0;
	}
}

customElements.define('tpt-popup-tab', PopupTabs);

/**
 * Tabs component
 */
class TabItem extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.displayTabContainer.bind(this));
		this.addEventListener('keypress', this.keyPress.bind(this));
	}

	keyPress(event) {
		if (event.key === 'Enter') {
			this.displayTabContainer(event);
		}
	}

	displayTabContainer(event) {
		event.preventDefault();

		const tabContainerTarget = this.getAttribute('data-tab-target');
		const tabAjaxUrl = this.getAttribute('data-ajax-url');

		if (tabAjaxUrl && !this.classList.contains('loaded')) {
			this.closest('tpt-tabs-component').classList.add('component-loading');
			this.classList.add('loading');

			if (this.classList.contains('active')) {
				return;
			} else {
				const ajaxDataElement = this.closest('tpt-tabs-component').querySelector('[data-ajax-content="' + tabContainerTarget + '"]');

				fetch(tabAjaxUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const elementToGet = this.getAttribute('data-ajax-element');

						const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

						if (elementToGet) {
							const tabContentHtml = responseHTML.querySelector(elementToGet);
							ajaxDataElement.innerHTML = tabContentHtml.innerHTML;
						} else {
							ajaxDataElement.innerHTML = responseText;
						}
					})
					.finally(() => {
						this.activeTabContainer();
						this.classList.add('loaded');
						this.classList.remove('loading');
						this.closest('tpt-tabs-component').classList.remove('component-loading');
					});
			}
		} else {
			if (this.classList.contains('active')) {
				return;
			} else {
				this.activeTabContainer();
			}
		}
	}

	activeTabContainer() {
		const currentTabContainer = this.closest('tpt-tabs-component');
		const tabContainerTarget = this.getAttribute('data-tab-target');

		currentTabContainer.querySelectorAll('tpt-tab-item').forEach((element) => {
			element.classList.remove('active');
		});

		this.classList.add('active');

		currentTabContainer.querySelectorAll('tpt-tab-data').forEach((element) => {
			element.classList.remove('active');
		});

		currentTabContainer.querySelector('[data-tab-container="' + tabContainerTarget + '"]').classList.add('active');
	}
}

customElements.define('tpt-tab-item', TabItem);

/**
 * Accordion component
 */
class AccordionHeader extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.displayAccordionContainer.bind(this));
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.displayAccordionContainer(e);
		}
	}

	displayAccordionContainer(event) {
		event.preventDefault();

		const currentAccordion = this.closest('tpt-accordion-component');
		const currentAccordionItem = this.closest('tpt-accordion-item');

		if (currentAccordion.getAttribute('data-type') == 'group') {
			if (currentAccordionItem.classList.contains('active')) {
				currentAccordionItem.classList.remove('active');
				return;
			} else {
				currentAccordion.querySelectorAll('tpt-accordion-item').forEach((element) => {
					element.classList.remove('active');
				});

				currentAccordionItem.classList.add('active');
				return;
			}
		} else {
			currentAccordionItem.classList.toggle('active');
		}
	}
}

customElements.define('tpt-accordion-title', AccordionHeader);

class ProductGallery extends HTMLElement {
	constructor() {
		super();

		const galleryContainer = this;
		const mainSwiper = this.querySelector('.gallery-main .swiper');
		const mainNext = this.querySelector('.gallery-main .swiper-button-next');
		const mainPrev = this.querySelector('.gallery-main .swiper-button-prev');
		const desktopColumn = parseInt(this.getAttribute('data-desktop-column'));
		const tabletColumn = parseInt(this.getAttribute('data-tablet-column'));
		const mobileColumn = parseInt(this.getAttribute('data-mobile-column'));

		const thumbSwiper = this.querySelector('.gallery-thumb .swiper');
		const thumbNext = this.querySelector('.gallery-thumb .swiper-button-next');
		const thumbPrev = this.querySelector('.gallery-thumb .swiper-button-prev');

		if (this.closest('tpt-modal-component')) {
			var swiperMain = new Swiper(mainSwiper, {
				spaceBetween: 16,
				slidesPerView: 'auto',
				autoHeight: false,
				allowTouchMove: true,
				navigation: {
					nextEl: mainNext,
					prevEl: mainPrev,
				},
				keyboard: {
					enabled: true,
				},
			});
		} else {
			var swiperThumb = new Swiper(thumbSwiper, {
				spaceBetween: 10,
				autoHeight: false,
				allowTouchMove: true,
				navigation: {
					nextEl: thumbNext,
					prevEl: thumbPrev,
				},
				keyboard: {
					enabled: true,
				},
				breakpoints: {
					0: {
						slidesPerView: 4,
						slidesPerGroup: mobileColumn,
					},
					768: {
						slidesPerView: 6,
						slidesPerGroup: tabletColumn,
					},
					1280: {
						slidesPerView: 6,
					},
				},
			});

			var swiperMain = new Swiper(mainSwiper, {
				spaceBetween: 10,
				autoHeight: false,
				allowTouchMove: true,
				navigation: {
					nextEl: mainNext,
					prevEl: mainPrev,
				},
				keyboard: {
					enabled: true,
				},
				breakpoints: {
					0: {
						slidesPerView: mobileColumn,
						slidesPerGroup: mobileColumn,
					},
					768: {
						slidesPerView: tabletColumn,
						slidesPerGroup: tabletColumn,
					},
					1280: {
						slidesPerView: desktopColumn,
						slidesPerGroup: desktopColumn,
					},
				},
				thumbs: {
					swiper: swiperThumb,
				},
			});
		}

		swiperMain.on('transitionEnd', function () {
			window.pauseAllMedia();

			if (mainSwiper.querySelector('.swiper-slide-active')) {
				const slideMediaType = mainSwiper.querySelector('.swiper-slide-active').getAttribute('data-media-type');

				if (slideMediaType == 'video' || slideMediaType == 'model') {
					galleryContainer.classList.add('hidden-lightbox');
					swiperMain.allowTouchMove = false;
				} else {
					galleryContainer.classList.remove('hidden-lightbox');
					swiperMain.allowTouchMove = true;
				}
			}
		});
	}
}

customElements.define('tpt-product-gallery', ProductGallery);

/**
 * Galllery featured product
 */
class ProductGalleryFeatured extends HTMLElement {
	constructor() {
		super();

		const galleryContainer = this;
		const mainSwiper = this.querySelector('.gallery-main .swiper');
		const mainNext = this.querySelector('.gallery-main .swiper-button-next');
		const mainPrev = this.querySelector('.gallery-main .swiper-button-prev');

		var swiperMain = new Swiper(mainSwiper, {
			slidesPerView: 1,
			spaceBetween: 20,
			autoHeight: false,
			allowTouchMove: true,
			navigation: {
				nextEl: mainNext,
				prevEl: mainPrev,
			},
			keyboard: {
				enabled: true,
			},
		});

		swiperMain.on('transitionEnd', function () {
			window.pauseAllMedia();

			if (mainSwiper.querySelector('.swiper-slide-active')) {
				const slideMediaType = mainSwiper.querySelector('.swiper-slide-active').getAttribute('data-media-type');

				if (slideMediaType == 'video' || slideMediaType == 'model') {
					galleryContainer.classList.add('hidden-lightbox');
					swiperMain.allowTouchMove = false;
				} else {
					galleryContainer.classList.remove('hidden-lightbox');
					swiperMain.allowTouchMove = true;
				}
			}
		});
	}
}

customElements.define('tpt-product-gallery-featured', ProductGalleryFeatured);
/**
 * Gallery lightbox
 */

/**
 * Video
 */

class PlayVideo extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.playVideo);
	}

	playVideo() {
		const videoId = this.getAttribute('data-poster-id');

		setTimeout(() => {
			document.getElementById(videoId).click();
		}, 300);
	}
}

customElements.define('tpt-play-video', PlayVideo);

/**
 * Open sidebar menu
 */
class TptMenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.defaultColor = this.getAttribute('data-default-color');

		this.addEventListener('click', this.openModal);
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.openModal(e);
		}
	}

	openModal(e) {
		e.preventDefault();

		const modalId = this.getAttribute('data-modal-target');
		const modalComponent = document.getElementById(modalId);

		//const btnOpenModal = this;

		if (this.classList.contains('active')) {
			this.classList.remove('active');
			this.setAttribute('aria-expanded', false);
			this.closest('.change-color-header').classList.remove(this.defaultColor);
			document.getElementsByTagName('html')[0].classList.remove('open-modal', 'header-menu-drawer');
			modalComponent.classList.remove('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		} else {
			this.classList.add('active');
			this.setAttribute('aria-expanded', true);
			this.closest('.change-color-header').classList.add(this.defaultColor);
			document.getElementsByTagName('html')[0].classList.add('open-modal', 'header-menu-drawer');
			modalComponent.classList.add('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		}
	}
}

customElements.define('tpt-menu-drawer', TptMenuDrawer);

/**
 * Copy text to clipboard
 */

var clipboardTimeoout;

class CopyClipboard extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.copyClipboard.bind(this));
	}

	copyClipboard() {
		clearTimeout(clipboardTimeoout);

		const text = this.querySelector('.tpt-clipboard__text').value;

		navigator.clipboard.writeText(text);

		this.classList.add('copied');

		clipboardTimeoout = setTimeout(() => {
			this.classList.remove('copied');
		}, 4000);
	}
}

customElements.define('tpt-copy-clipboard', CopyClipboard);

/**
 * Account tab login register
 */

class TptTabAccount extends HTMLElement {
	constructor() {
		super();

		const tabItems = this.querySelectorAll('.tpt-tab-account__list-item');

		tabItems.forEach((tabItem) => {
			tabItem.addEventListener('click', this.showTab);
		});
	}

	showTab() {
		if (!this.classList.contains('active')) {
			const tabAccountComponent = this.closest('tpt-tab-account');
			const tabDataId = this.getAttribute('data-target');

			tabAccountComponent.querySelectorAll('.tpt-tab-account__content').forEach((tabData) => {
				tabData.classList.remove('active');
			});

			tabAccountComponent.querySelectorAll('.tpt-tab-account__list-item').forEach((tabItem) => {
				tabItem.classList.remove('active');
			});

			this.classList.add('active');
			document.getElementById(tabDataId).classList.add('active');
		}
	}
}

customElements.define('tpt-tab-account', TptTabAccount);

/**
 * Check password
 */

function containsUppercase(str) {
	return /[A-Z]/.test(str);
}

function containsLowcase(str) {
	return /[a-z]/.test(str);
}

function containsNumber(str) {
	return /[0-9]/.test(str);
}

/**
 * Validate form Register
 */

function validateEmail(email) {
	return String(email)
		.toLowerCase()
		.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/);
}

if (!customElements.get('tpt-validate-register')) {
	customElements.define(
		'tpt-validate-register',
		class TptValidateRegister extends HTMLElement {
			constructor() {
				super();

				this.firstName = this.querySelector('[name="customer[first_name]"]');
				this.lastName = this.querySelector('[name="customer[last_name]"]');
				this.email = this.querySelector('[name="customer[email]"]');
				this.passInput = this.querySelector('[type="password"]');
				this.buttonSubmit = this.querySelector('[type="submit"]');

				this.firstName.addEventListener('keyup', this.validateRegister.bind(this));
				this.lastName.addEventListener('keyup', this.validateRegister.bind(this));
				this.email.addEventListener('keyup', this.validateRegister.bind(this));
				this.passInput.addEventListener('keyup', this.validateRegister.bind(this));

				this.validateRegister();
			}

			validateRegister() {
				var checkFirstName = false;
				var checkLastName = false;
				var checkEmail = false;
				var checkPassword = false;

				this.firstName.value ? (checkFirstName = true) : (checkFirstName = false);
				this.lastName.value ? (checkLastName = true) : (checkLastName = false);
				validateEmail(this.email.value) ? (checkEmail = true) : (checkEmail = false);

				/**
				 * Check password
				 */

				const passRequirements = this.closest('tpt-pass-requirements');

				let min = false;
				let number = false;
				let uppercase = false;
				let lowercase = false;

				const passString = this.passInput.value;

				if (passString.length >= 8) {
					min = true;
					this.querySelector('[data-requirements-min]').classList.add('active');
				} else {
					min = false;
					this.querySelector('[data-requirements-min]').classList.remove('active');
				}

				if (containsUppercase(passString)) {
					uppercase = true;
					this.querySelector('[data-requirements-uppercase]').classList.add('active');
				} else {
					uppercase = false;
					this.querySelector('[data-requirements-uppercase]').classList.remove('active');
				}

				if (containsLowcase(passString)) {
					lowercase = true;
					this.querySelector('[data-requirements-lowercase]').classList.add('active');
				} else {
					lowercase = false;
					this.querySelector('[data-requirements-lowercase]').classList.remove('active');
				}

				if (containsNumber(passString)) {
					number = true;
					this.querySelector('[data-requirements-number]').classList.add('active');
				} else {
					number = false;
					this.querySelector('[data-requirements-number]').classList.remove('active');
				}

				if (min && number && uppercase && lowercase) {
					checkPassword = true;
				} else {
					checkPassword = false;
				}

				/**
				 * End check passs
				 */

				if (checkFirstName && checkLastName && checkEmail && checkPassword) {
					this.buttonSubmit.removeAttribute('disabled');
				} else {
					this.buttonSubmit.setAttribute('disabled', 'disabled');
				}
			}
		}
	);
}

/**
 * Validate form Login
 */

if (!customElements.get('tpt-validate-login')) {
	customElements.define(
		'tpt-validate-login',
		class TptValidateLogin extends HTMLElement {
			constructor() {
				super();

				this.email = this.querySelector('[name="customer[email]"]');
				this.passInput = this.querySelector('[type="password"]');
				this.buttonSubmit = this.querySelector('[type="submit"]');

				this.email.addEventListener('keyup', this.validateLogin.bind(this));
				this.passInput.addEventListener('keyup', this.validateLogin.bind(this));

				this.validateLogin();
			}

			validateLogin() {
				var checkEmail = false;
				var checkPassword = false;

				this.passInput.value ? (checkPassword = true) : (checkPassword = false);
				validateEmail(this.email.value) ? (checkEmail = true) : (checkEmail = false);

				if (checkEmail && checkPassword) {
					this.buttonSubmit.removeAttribute('disabled');
				} else {
					this.buttonSubmit.setAttribute('disabled', 'disabled');
				}
			}
		}
	);
}

/**
 * Validate form reset password
 */

if (!customElements.get('tpt-validate-reset-password')) {
	customElements.define(
		'tpt-validate-reset-password',
		class TptValidateResetPassword extends HTMLElement {
			constructor() {
				super();

				this.email = this.querySelector('[type="email"]');
				this.buttonSubmit = this.querySelector('[type="submit"]');

				this.email.addEventListener('keyup', this.validateResetPassword.bind(this));

				this.validateResetPassword();
			}

			validateResetPassword() {
				var checkEmail = false;

				validateEmail(this.email.value) ? (checkEmail = true) : (checkEmail = false);

				if (checkEmail) {
					this.buttonSubmit.removeAttribute('disabled');
				} else {
					this.buttonSubmit.setAttribute('disabled', 'disabled');
				}
			}
		}
	);
}

/**
 * Validate password
 */

if (!customElements.get('tpt-validate-password')) {
	customElements.define(
		'tpt-validate-password',
		class TptValidatePassword extends HTMLElement {
			constructor() {
				super();

				this.passInput = this.querySelector('[type="password"]');
				this.buttonSubmit = this.querySelector('[type="submit"]');

				this.passInput.addEventListener('keyup', this.validatePassword.bind(this));

				this.validatePassword();
			}

			validatePassword() {
				var checkPassword = false;

				/**
				 * Check password
				 */

				const passRequirements = this.closest('tpt-pass-requirements');

				let min = false;
				let number = false;
				let uppercase = false;
				let lowercase = false;

				const passString = this.passInput.value;

				if (passString.length >= 8) {
					min = true;
					this.querySelector('[data-requirements-min]').classList.add('active');
				} else {
					min = false;
					this.querySelector('[data-requirements-min]').classList.remove('active');
				}

				if (containsUppercase(passString)) {
					uppercase = true;
					this.querySelector('[data-requirements-uppercase]').classList.add('active');
				} else {
					uppercase = false;
					this.querySelector('[data-requirements-uppercase]').classList.remove('active');
				}

				if (containsLowcase(passString)) {
					lowercase = true;
					this.querySelector('[data-requirements-lowercase]').classList.add('active');
				} else {
					lowercase = false;
					this.querySelector('[data-requirements-lowercase]').classList.remove('active');
				}

				if (containsNumber(passString)) {
					number = true;
					this.querySelector('[data-requirements-number]').classList.add('active');
				} else {
					number = false;
					this.querySelector('[data-requirements-number]').classList.remove('active');
				}

				if (min && number && uppercase && lowercase) {
					checkPassword = true;
				} else {
					checkPassword = false;
				}

				/**
				 * End check passs
				 */

				if (checkPassword) {
					this.buttonSubmit.removeAttribute('disabled');
				} else {
					this.buttonSubmit.setAttribute('disabled', 'disabled');
				}
			}
		}
	);
}
